import { render, staticRenderFns } from "./closedIndex.vue?vue&type=template&id=ada7b79a"
import script from "./closedIndex.vue?vue&type=script&lang=js"
export * from "./closedIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ada7b79a')) {
      api.createRecord('ada7b79a', component.options)
    } else {
      api.reload('ada7b79a', component.options)
    }
    module.hot.accept("./closedIndex.vue?vue&type=template&id=ada7b79a", function () {
      api.rerender('ada7b79a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/inbound/closedIndex.vue"
export default component.exports